import React, { useState, useRef } from 'react';
import { message, Checkbox } from 'antd';
import { debounce } from 'lodash';
import { ORIGINCOPYLISTEMUN } from './../../activity-receipt-config';
import apis from './../../apis';
import './index.less';

/****************
 * 活动复制弹窗【只有活动管理模块有】
 * *****************/
export default function ActivityCopyWrapper(props) {
  const { setIsCopyModalVisible, activityId, onCopySuccess } = props;
  const [activitySetting, setActivitySetting] = useState(ORIGINCOPYLISTEMUN.ACTIVITYSETTING.default);
  const [areaSetting, setAreaSetting] = useState(ORIGINCOPYLISTEMUN.AREASETTING.default);
  const [qualificationSetting, setQualificationSetting] = useState(ORIGINCOPYLISTEMUN.QUALIFICATIONSETTING.default);
  const [batchSetting, setBatchSetting] = useState(ORIGINCOPYLISTEMUN.BATCHSETTING.default);
  const modalContentHasModify = useRef(false);

  function changeAreaSetting(e) {
    setAreaSetting(e.target.checked);
    if (!e.target.checked) {
      setQualificationSetting(false);
      setBatchSetting(false);
    }
  }

  function changeQualificationSetting(e) {
    setQualificationSetting(e.target.checked);
    if (e.target.checked && !areaSetting) {
      setAreaSetting(true);
    }
  }

  function changeBatchSetting(e) {
    setBatchSetting(e.target.checked);
    if (e.target.checked && !areaSetting) {
      setAreaSetting(true);
    }
  }

  /***************** modal行为处理 *****************/
  async function okCopySubmit() {
    const { ret, msg } = await apis.fetchaActivityCopy({
      activityId,
      activitySetting: Number(activitySetting),
      areaSetting: Number(areaSetting),
      qualificationSetting: Number(qualificationSetting),
      batchSetting: Number(batchSetting),
    });
    if (ret === '0') {
      message.success(`活动复制中,请稍后点击复制结果查看`);
      modalContentHasModify.current = true;
    } else {
      message.error(`${msg || '活动复制失败，请您稍后重试！'}`);
    }
    cancelCopyModal();
  }

  function cancelCopyModal() {
    setIsCopyModalVisible(false);
    setActivitySetting(ORIGINCOPYLISTEMUN.ACTIVITYSETTING.default);
    setAreaSetting(ORIGINCOPYLISTEMUN.AREASETTING.default);
    setQualificationSetting(ORIGINCOPYLISTEMUN.QUALIFICATIONSETTING.default);
    setBatchSetting(ORIGINCOPYLISTEMUN.BATCHSETTING.default);
    //只要框内有增删改查或其他接口行为都刷新
    if (modalContentHasModify.current) {
      onCopySuccess();
    }
    modalContentHasModify.current = false;
  }

  return (
    <div className="activity-copy-modal-fa">
      <div className="modal-top-tips">请选择需要复制的内容</div>
      <div className="group-checkbox-fa">
        <Checkbox defaultChecked disabled checked={activitySetting} className="group-checkbox-item">
          {ORIGINCOPYLISTEMUN.ACTIVITYSETTING.name}
        </Checkbox>
        <Checkbox checked={areaSetting} className="group-checkbox-item" onChange={changeAreaSetting}>
          {ORIGINCOPYLISTEMUN.AREASETTING.name}
        </Checkbox>
        <Checkbox checked={qualificationSetting} className="group-checkbox-item" onChange={changeQualificationSetting}>
          {ORIGINCOPYLISTEMUN.QUALIFICATIONSETTING.name}
        </Checkbox>
        <Checkbox checked={batchSetting} className="group-checkbox-item" onChange={changeBatchSetting}>
          {ORIGINCOPYLISTEMUN.BATCHSETTING.name}
        </Checkbox>
      </div>
      <div className="modal-btns-fa">
        <span className="modal-btn-item modal-cancle-btn" onClick={debounce(() => cancelCopyModal(), 300)}>
          取消
        </span>
        <span className="modal-btn-item modal-sure-btn" onClick={debounce(() => okCopySubmit(), 300)}>
          确定
        </span>
      </div>
    </div>
  );
}
